var map = {
	"./gallery-wip-neck_00.jpg": 3982,
	"./gallery-wip-neck_01.jpg": 3983,
	"./gallery-wip-neck_02.jpg": 3984,
	"./gallery-wip-neck_03.jpg": 3985,
	"./gallery-wip-neck_04.jpg": 3986,
	"./gallery-wip-neck_05.jpg": 3987,
	"./gallery-wip-neck_06.jpg": 3988,
	"./gallery_00.jpg": 3989,
	"./gallery_01.jpg": 3990,
	"./gallery_02.jpg": 3991,
	"./gallery_03.jpg": 3992,
	"./gallery_04.jpg": 3993,
	"./gallery_05.jpg": 3994,
	"./gallery_06.jpg": 3995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3981;